//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userobject from "../../script/userobject";
import comicobject from "../../script/comicobject";

export default {
  name: "buy",
  props: {
    comic_data: undefined,
    current_chapter: undefined,
    tabinfo: undefined
  },
  mixins: [userobject],
  data() {
    return {
      total_buy_gold: undefined,
      total_buy_chapter: undefined,
      confirm_buy: false,
      buy_message: undefined,
      user_vip_degree: undefined,
      buy_loading: false,
      current_buy_chapter_list: [],
      buy_gold_num: undefined,
      total_buy_gold_num: undefined
    }
  },
  created() {
    window._buy_item = this;
    console.log("buy comic_data:", this.comic_data);
    var buy_chapter_conf = this.comic_data.buy_chapter_conf;
    var pay_chapters = buy_chapter_conf.pay_chapters;
    var comic_buy = this.tabinfo.comic_buy;
    this.total_buy_chapter = pay_chapters;

    if (comic_buy) {
      if (comic_buy.chapter_list && Array.isArray(comic_buy.chapter_list)) {
        this.total_buy_chapter = pay_chapters.filter(el => !comic_buy.chapter_list.includes(el))
      }
    }

    console.log("total_buy_chapter:", this.total_buy_chapter);

    var buy_all_chapter_num = this.total_buy_chapter.length;
    this.total_buy_gold = parseInt((buy_all_chapter_num * this._g.buy_chapter.gold) * this._g.buy_chapter.all_buy_discount);
    this.user_vip_degree = this.this_vip_degree()

    this.buy_gold_num = parseInt(this._g.buy_chapter.gold * this.user_vip_degree.discount);
    this.total_buy_gold_num = parseInt(this.total_buy_gold * this.user_vip_degree.discount)
  },
  methods: {
    on_buy: function () {
      if (!this.$store.state.hasLogin) {
        return this.$app._userbar.show_login_dialog();
      }
      this.current_buy_chapter_list = [this.current_chapter]
      this.buy_message = this.$stringFormat('是否确定购买此章节,支付{0}金币?', [this.buy_gold_num])
      this.confirm_buy = true;
    },
    on_buy_all: function () {
      if (!this.$store.state.hasLogin) {
        return this.$app._userbar.show_login_dialog();
      }
      this.current_buy_chapter_list = this.total_buy_chapter
      this.buy_message = this.$stringFormat('是否确定购买所有章节,支付{0}金币?', [this.total_buy_gold_num])
      this.confirm_buy = true;
    },
    buy_chapter: function ({chapter_list, cb}) {

      this.buy_loading = true;
      var post_data = {
        'id': this.comic_data.id,
        'chapter_list': chapter_list,
      };

      this.$axios.post("/app/comic/buy", post_data).then((response) => {
        this.buy_loading = false;
        console.log('buy_chapter response:', response);
        this.tabinfo.comic_buy.chapter_list = this.tabinfo.comic_buy.chapter_list.concat(chapter_list);
        this.$messageX("购买成功！")
      }).catch((error) => {
        console.log('buy error:', error)
        this.buy_loading = false;
        this.$messageX("出现错误，请尝试刷新页面！")

      });
    },
    on_buy_reslut: function () {

    }
  },
}
